const uSwitchPrimary = "#141424";
const uSwitchPrimaryTextColor = "white";

const uSwitchSecondary = "#F3F3F4";
const uSwitchSecondaryTextColor = "#141424";

const uSwitchStylesCommon: React.CSSProperties = {
  boxShadow: "none",
  borderRadius: 0,
  padding: "16px 65px",
};

export const uSwitchStylesPrimary: React.CSSProperties = {
  ...uSwitchStylesCommon,
  backgroundColor: uSwitchPrimary,
  color: uSwitchPrimaryTextColor,
};

export const uSwitchStylesSecondary: React.CSSProperties = {
  ...uSwitchStylesCommon,
  backgroundColor: uSwitchSecondary,
  color: uSwitchSecondaryTextColor,
};
